import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { API_URL } from './appApi';

export const AppLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const redirect = location.state?.from || '/app/home';

  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    document.body.classList.add('pwa-mode');
    const badge = document.getElementById('emergent-badge');
    if (badge) badge.style.display = 'none';
    return () => {
      document.body.classList.remove('pwa-mode');
      if (badge) badge.style.display = '';
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append('password', password);
      const res = await fetch(`${API_URL}/api/admin/login`, { method: 'POST', body: fd });
      if (res.ok) {
        sessionStorage.setItem('admin_password', password);
        navigate(redirect, { replace: true });
      } else {
        setError('Incorrect password. Try again.');
      }
    } catch (_) {
      setError('Connection error. Check your signal and try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-600 to-cyan-700 flex flex-col items-center justify-center px-6 py-10">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-white shadow-lg mb-4 p-2">
            <img
              src="/pawsome-logo.jpg"
              alt="Pawsome Ventures"
              className="w-full h-full object-contain rounded-xl"
            />
          </div>
          <h1 className="text-3xl font-bold text-white">Pawsome Admin</h1>
          <p className="text-teal-100 text-sm mt-1">Sign in to continue</p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="bg-white rounded-2xl shadow-xl p-6 space-y-4"
          data-testid="app-login-form"
        >
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <Lock className="w-4 h-4 inline mr-1" />
              Admin password
            </label>
            <input
              type="password"
              autoFocus
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              className="w-full px-4 py-3 text-base border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent"
              data-testid="app-login-password"
            />
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-800 px-3 py-2 rounded-lg text-sm">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading || !password}
            className="w-full py-3 text-base font-semibold bg-teal-600 text-white rounded-xl hover:bg-teal-700 active:scale-[0.98] transition disabled:opacity-50"
            data-testid="app-login-submit"
          >
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        <p className="text-center text-teal-100 text-xs mt-6">
          Pawsome Ventures · Pet Travel & Relocation
        </p>
      </div>
    </div>
  );
};
